import type { DeviceViewEntityTabMouseEvent } from 'components/DeviceView/DeviceViewHeader';
import type {
  DeviceViewEdgeEntity,
  DeviceViewEntity,
  DeviceViewNodeEntity,
} from 'components/DeviceView/deviceViewTypes';
import { isDeviceViewEdgeStructure } from 'components/DeviceView/helpers/isDeviceViewEdgeStructure';
import { isDeviceViewNodeStructure } from 'components/DeviceView/helpers/isDeviceViewNodeStructure';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import { unhighlightEdge } from '../edges/unhighlightEdge';
import { unhighlightGraphNode } from '../pathLookup/unhighlightGraphNode';

export const unhighlightPathLookupPathInspectorElement: GraphCommandFactory<
  DeviceViewEntityTabMouseEvent
> = (cmdContext, dispatch) => async (command) => {
  if (isDeviceViewNodeStructure(command)) {
    const deviceViewEntity = cmdContext
      .getDeviceView()
      .deviceViewEntities.find(
        (entity: DeviceViewEntity): entity is DeviceViewNodeEntity =>
          entity.deviceViewElement === 'node' &&
          entity.id === command.deviceViewEntityId,
      );
    if (deviceViewEntity !== undefined) {
      dispatch(unhighlightGraphNode, { nodeSn: deviceViewEntity.sn });
    }
  } else if (isDeviceViewEdgeStructure(command)) {
    const deviceViewEntity = cmdContext
      .getDeviceView()
      .deviceViewEntities.find(
        (entity: DeviceViewEntity): entity is DeviceViewEdgeEntity =>
          entity.deviceViewElement === 'edge' &&
          entity.id === command.deviceViewEntityId,
      );
    if (deviceViewEntity !== undefined) {
      dispatch(unhighlightEdge, {
        edgeId: deviceViewEntity.edgeId,
        color: true,
        thickness: true,
      });
    }
  }
};
